import { TREELY_CDN_URI } from "@/constants/cdn";
import { CategoryType } from "@/types/category";

// Helper function to get category-specific images
export const getCategoryImageUrl = (category: CategoryType): string => {
  // Using available forest images for different categories
  const imageMap: Record<CategoryType, string> = {
    afforestation: `${TREELY_CDN_URI}/afforestation.webp`,
    communityEngagement: `${TREELY_CDN_URI}/community-engagement.webp`,
    forestInfrastructure: `${TREELY_CDN_URI}/forest-infrastructure.webp`,
    forestSanitation: `${TREELY_CDN_URI}/forest-sanitation.webp`,
    forestTending: `${TREELY_CDN_URI}/forest-tending-2.webp`,
    harvesting: `${TREELY_CDN_URI}/harvesting.webp`,
    inventory: `${TREELY_CDN_URI}/inventory.webp`,
    natureConservation: `${TREELY_CDN_URI}/nature-conservation.webp`,
    regeneration: `${TREELY_CDN_URI}/regeneration.webp`,
    wildlifeManagement: `${TREELY_CDN_URI}/wildlife-management.webp`,
  };

  return imageMap[category] || "";
};
